module.exports = __webpack_public_path__ + "nunito-sans-latin-900italic.708845e875a3b08640369bf84fd65472.woff";